import { CellEventFormatterProps, contentTypeMap } from '../../utils'
import React from 'react'
import styled from 'styled-components/macro'

export const NoteUpdateEvent = ({ event }: CellEventFormatterProps) => {
  const noteType = contentTypeMap[event.content_type.model] ?? 'Note'

  return (
    <span>
      edited a <GreenBold>{noteType}</GreenBold>
    </span>
  )
}

export const GreenBold = styled.b`
  color: #087443;
`
